<template>
  <div v-if="is_show_filter" class="works-filter__block works-filter__block-period active cost">
    <div class="works-filter__block-item">
      <div class="works-filter__block-title">{{ $t("message.Price") }}</div>
    </div>

    <div class="period-range">
      <div class="item-cell">
        <input v-model.number="price_min"
               v-on:blur="set_price_min(price_min_in)" v-on:keyup.enter="set_price_min(price_min_in)"
               type="" onkeypress="return is_input_digits(event)" name="" :placeholder="$t('message.PriceFrom')" class="ref-input ref-input-md">
      </div>
      <div class="item-cell">
        <input v-model.number="price_max"
               v-on:blur="set_price_max(price_max_in)" v-on:keyup.enter="set_price_max(price_max_in)"
               type="" onkeypress="return is_input_digits(event)" name="" :placeholder="$t('message.PriceTo')" class="ref-input ref-input-md">
      </div>
    </div>

    <label v-for="(val, index) in values" class="works-filter__labels text-uppercase">
      <span class="checkbox">
        <input type="radio" name="cost" v-model="currency" :value="val"/>
        <span class="check"/>
      </span>
      {{ val.label_text }}
    </label>
  </div>
</template>


<script>
  import dropdownSub from "../../../../_common/components/lib/dropdownSub";
  import FilterPriceMix from "../../../../../components/list/filter/FilterPriceMix";

  export default {
    components: { dropdownSub },
    name      : 'filter-price-sub',
    props:{
      is_show: { type: Boolean, default: true },
    },
    mixins: [FilterPriceMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/filter/FilterPriceSub.vue